import { SurfaceBadge } from '@/components/match/surface-badge';
import type { MatchSearchResult } from '@tennis-scanner/shared';
import { Calendar } from 'lucide-react';

// Top-of-page identity card for a match: names + tournament + surface + start.
// Used by the cockpit (full screen) and could be reused by any future detail page.

interface Props {
  match: MatchSearchResult | undefined;
  fallbackId: string;
}

export function MatchHeader({ match, fallbackId }: Props) {
  const title =
    match?.p1Name && match.p2Name
      ? `${match.p1Name} vs ${match.p2Name}`
      : `Match ${fallbackId.slice(0, 8)}`;
  return (
    <header className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <SurfaceBadge surface={match?.surface ?? null} />
        {match?.bestOf && (
          <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            BO{match.bestOf}
          </span>
        )}
        {match?.status && (
          <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            {match.status}
          </span>
        )}
      </div>
      <h1 className="font-brand text-3xl tracking-[0.2em] text-foreground">{title}</h1>
      {(match?.tournamentName || match?.startsAt) && (
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          {match?.tournamentName && <span>{match.tournamentName}</span>}
          {match?.startsAt && (
            <>
              <span aria-hidden="true">·</span>
              <Calendar className="size-3.5" />
              <span className="font-mono">{new Date(match.startsAt).toLocaleString()}</span>
            </>
          )}
        </p>
      )}
    </header>
  );
}
